import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VATRefNo: "",
    A_VocNo: "0",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_RefDt: new Date(), // dd/MM/yyyy
    A_RefNo: "",
    A_Party: "",
    A_PartyName: "",
    A_Curr: "",
    A_Currname: "",
    A_ExRate: 1, // Decimal
    A_PayMode: "CREDIT",
    A_Type: "LOCAL",
    A_Br: "", //LocationBrCode
    A_BrName: "", //location branchName
    A_Loc: "",
    A_LocName: "",
    A_Buyer: "",
    A_Buyername: "",
    A_Narr: "",
    A_CrAc: "",
    A_CrAcName: "",
    A_DrAc: "",
    A_DrAcName: "",
    A_GrossAmt: 0, //decimal
    A_DiscPerc: 0, //decimal
    A_DiscAmt: 0, //decimal
    A_DiscFlag: "Y",
    A_Rounding: 0, //decimal
    A_TaxAmt: 0, //decimal
    A_NetAmt: 0, //decimal
    A_LC: 0, //decimal
    A_Charges1: 0, //decimal
    A_Charges2: 0, //decimal
    A_DocStat: "ENTER",
    TaxType: "INTRN001", //tax  ->      // INTRN001->VAT		INTRN002->INTER COMPANY  INTRN002->IMPORT
    A_CUSTFIELD3Name: "",
    A_CUSTFIELD4: "N",
    UnloadingBay: "", // Unloading Bin ID
    UnloadingBayName: "", // Unloading Bin Name
    Type: "", // From     // VENDOR_INV->Vendor		TRANSFER_RETURN->Outlet		SALES_RETURN ->Sales Return
    A_CUSTFIELD8: "",
    A_CUSTFIELD9: "",
    A_ExciseTaxNetAmt: 0, //Decimal
    A_TaxGross: "N",
    A_Taxable: "Y",
    A_ScaleItm: "N",
    A_TCS: 0, //Decimal
    Source: "",
    A_RefDocTyp: "",
    A_RefDocTypName: "",
    A_RefDocNo: "",
    A_RefDocVer: 0, //Int
    VendorInvAmount: 0, //INvoice Amount
    offer: "N", // Offer Y/N
    salesGroup: "", 
    A_AutoBatch: "N",
    virtualBin: "",
    RCM: "N",
    Weighing: "N",
    Tax: "Y",
    TaxGross: "N",
    PurchaseReturnType:"",
    Salesman:"",  
    Rebate:"N",
    Batch:"No",//textbox,
    POBarcode:""
  },
  // BufferObject: {
  //   B_VocTyp: "",
  //   B_VocNo: "",
  //   B_Srno: 0,
  //   B_Itmcd: "",
  //   B_ItmName: "",
  //   B_Qty: 0,
  //   B_Unit: "",
  //   B_UnitName: "",
  //   B_BaseQty: 0,
  //   B_URateFc: 0,
  //   B_URateLc: 0,
  //   B_GrossAmt: 0,
  //   B_LDiscPerc: 0,
  //   B_LDiscAmt: 0,
  //   B_TDiscPerc: 0.00,
  //   B_TDiscAmt: 0,
  //   B_FocFlag: "N",
  //   B_AprmtFlag: "",
  //   B_FocAmt: 0,
  //   B_NetAmt: 0,
  //   B_TaxDept: "",
  //   B_TaxPerc: 0,
  //   B_TaxAmt: 0,
  //   B_TaxDept2: "",
  //   B_TaxPerc2: 0,
  //   B_TaxAmt2: 0,
  //   B_LC: 0,
  //   B_Charges1: 0,
  //   B_Charges2: 0,
  //   B_Rounding: 0,
  //   B_LandVal: 0,
  //   B_RSP: 0,
  //   B_RefDocTyp: "",
  //   B_RefDocNo: "",
  //   B_RefNo1: "",
  //   B_RefNo2: "",
  //   B_RefNo3: "",
  //   B_RefNo4: 0,
  //   B_RefNo5: 0,
  //   B_RefNo6: 0,
  //   B_URate_Fixed: 0,
  //   B_CostPr: 0,
  //   B_ExciseTaxPerc: 0,
  //   B_ExciseTaxAmt: 0,
  //   B_ExciseTaxNetAmt: 0,
  //   B_IncGroup: "",
  //   B_SuprvPerc: 0,
  //   B_OthersPerc: 0,
  //   B_SLANSuprv: "",
  //   B_SlabAmtSuprv: 0,
  //   B_SLANOther: "",
  //   B_SlabAmtOther: 0
  // },

  Checkbox: {
    
    // SplDisc: false,
    // TDiscPercent: false,
    // TDiscAmt: false,
    // LDiscPercent: true,
    // LDiscAmt: true,
    // FOC: false,
    Excise: false,
    // BaseRate: false,
    Tax: true,
    // Rebate: false,
    Narration: false,
    Cess: false,
    AddCess: false,
    UnitRate:true,
    GrossAmt:false,
    NetValue:true, 
    // RefNo:true,
    // PalletId:true,
    // PalletType:true,
    ItemCode: true,
  },

  WmsSpinner: false,
};

const SliceVendorCreditNote = createSlice({
  name: "SliceVendorCreditNote",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_VendorCreditNote_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    //SPINNER
    Set_WmsSpinner_Init: (state, action) => {
      state.value.WmsSpinner = action.payload.WmsSpinner;
    },

    //RESET CHECKBOX
    Set_WmsInnModelCheckbox_Init: (state) => {
      state.value.Checkbox = {
        SplDisc: false,
        TDiscPercent: false,
        TDiscAmt: false,
        LDiscPercent: true,
        LDiscAmt: true,
        FOC: false,
        Excise: false,
        // BaseRate: false,
        Tax: true,
        Rebate: false,
        Narration: false,
        Cess: false,
        AddCess: false,
      };
    },

    Set_HeadObject_DrCrAccount: (state, action) => {
      state.value.HeadObject.A_CrAc = action.payload.A_CrAc;
      state.value.HeadObject.A_CrAcName = action.payload.A_CrAcName;
      state.value.HeadObject.A_DrAc = action.payload.A_DrAc;
      state.value.HeadObject.A_DrAcName = action.payload.A_DrAcName;
    },

    Set_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_WmsInnModelCheckbox: (state, action) => {
      state.value.Checkbox = action.payload;
    },

    Wms_HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_Loc = action.payload.A_Loc;
      state.value.HeadObject.A_Curr = action.payload.A_Curr;
      state.value.HeadObject.A_ExRate = action.payload.A_ExRate;
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.TaxType = action.payload.TaxType;
      state.value.HeadObject.PurchaseReturnType = action.payload.PurchaseReturnType;
      state.value.HeadObject.Type = action.payload.Type; 
      state.value.HeadObject.A_AutoBatch = action.payload.A_AutoBatch; 
    },

    Wms_HeadObject_RefNo_ExactSearch_Set: (state, action) => {
      state.value.HeadObject.A_RefDocTyp = action.payload.A_RefDocTyp;
      state.value.HeadObject.A_RefDocTypName = action.payload.A_RefDocTypName;
      state.value.HeadObject.A_RefDocNo = action.payload.A_RefDocNo;
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
      state.value.HeadObject.Type = action.payload.Type;
      state.value.HeadObject.UnloadingBay = action.payload.UnloadingBay;
      state.value.HeadObject.UnloadingBayName = action.payload.UnloadingBayName;
      state.value.HeadObject.A_PostDt = action.payload.A_PostDt;
      state.value.HeadObject.A_RefNo = action.payload.A_RefNo;
      state.value.HeadObject.A_RefDt = action.payload.A_RefDt;
      state.value.HeadObject.VendorInvAmount = action.payload.VendorInvAmount;
      state.value.HeadObject.A_RefDocVer = action.payload.A_RefDocVer;
    },

    Set_HeadObject_A_VocNo: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },

    Wms_HeadObject_SalesGroup_A_Buyer_Set: (state, action) => {
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
     
    },
    Set_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_HeadObject_virtualBin: (state, action) => {
      state.value.HeadObject.virtualBin = action.payload.virtualBin;
    },

 

    Set_HeadObject_A_PayMode: (state, action) => {
      state.value.HeadObject.A_PayMode = action.payload.A_PayMode;
    },
    Set_HeadObject_TaxType: (state, action) => {
      state.value.HeadObject.TaxType = action.payload.TaxType;
    },
    Set_HeadObject_salesGroup: (state, action) => {
      state.value.HeadObject.salesGroup = action.payload.salesGroup;
    },
    Set_HeadObject_DiscFlag: (state, action) => {
      state.value.HeadObject.A_DiscFlag = action.payload.A_DiscFlag;
    },
  },
});

export const {
  Set_VendorCreditNote_Init,
  Set_HeadObject_Set,
  Set_WmsInnModelCheckbox,
  Set_WmsInnModelCheckbox_Init,
  Wms_HeadObject_New_Set,
  Set_HeadObject_Init,
  Set_HeadObject_DrCrAccount,
  Set_HeadObject_A_VocNo,
  Set_HeadObject_A_DocStat,
  Set_HeadObject_A_PayMode,
  Set_WmsSpinner_Init, 
  Wms_HeadObject_RefNo_ExactSearch_Set,
  Set_HeadObject_TaxType,
  Set_HeadObject_salesGroup,
  Wms_HeadObject_SalesGroup_A_Buyer_Set,
  Set_HeadObject_DiscFlag,
  Set_HeadObject_virtualBin,
} = SliceVendorCreditNote.actions;
export default SliceVendorCreditNote.reducer;
